var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "24px",
    viewBox: "0 0 16 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/ui/user") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/ui/user",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#7A7A7A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.34293657,24 L0.578556952,24 C0.572588863,23.8736862 0.0717032455,18.8756623 0.0663763938,18.7564517 C0.0221254646,17.7661515 0,17.038997 0,16.875 C0,13.8124832 1.77591267,11.6231093 4.3693018,10.5957091 C4.58669546,10.7946751 4.82098329,10.9759955 5.0698131,11.1373549 C2.5321367,11.9773802 0.761904762,13.9666283 0.761904762,16.875 C0.761904762,17.0090004 0.761904762,17.8954537 0.847698523,19.125 L1.34293657,24 Z",
    id: "outline-left"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2724604,24 L11.5080808,24 C11.5021127,23.8736862 11.0012271,18.8756623 10.9959002,18.7564517 C10.9516493,17.7661515 10.9295238,17.038997 10.9295238,16.875 C10.9295238,13.8124832 12.7054365,11.6231093 15.2988256,10.5957091 C15.5162193,10.7946751 15.7505071,10.9759955 15.9993369,11.1373549 C13.4616605,11.9773802 11.6914286,13.9666283 11.6914286,16.875 C11.6914286,17.0090004 11.6914286,17.8954537 11.7772223,19.125 L12.2724604,24 Z",
    id: "outline-left",
    transform: "translate(13.464430, 17.297855) scale(-1, 1) translate(-13.464430, -17.297855) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,10.5 C10.9455187,10.5 13.3333333,8.14949494 13.3333333,5.25 C13.3333333,2.35050506 10.9455187,0 8,0 C5.05448133,0 2.66666667,2.35050506 2.66666667,5.25 C2.66666667,8.14949494 5.05448133,10.5 8,10.5 Z M8,9.75 C5.47526972,9.75 3.42857143,7.73528137 3.42857143,5.25 C3.42857143,2.76471863 5.47526972,0.75 8,0.75 C10.5247303,0.75 12.5714286,2.76471863 12.5714286,5.25 C12.5714286,7.73528137 10.5247303,9.75 8,9.75 Z",
    id: "outer"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.32f6a78ce7eb225cce7d23c9d277520f.svg";
export { ForwardRef as ReactComponent };